
new Swiper('.buly-product-carousel', {
    slidesPerView: 1.25,
    spaceBetween: 15,
    watchSlidesProgress: true,
    breakpoints: {
      450: {
        slidesPerView: 1.75,
        spaceBetween: 20
      },
      600: {
        slidesPerView: 2.25,
        spaceBetween: 20
      },
      800: {
        slidesPerView: 2.75,
        spaceBetween: 20
      },
      990: {
        slidesPerView: 2.25,
        spaceBetween: 20
      },
      1250: {
        slidesPerView: 2.75,
        spaceBetween: 20
      },
      1650: {
        slidesPerView: 3.75,
        spaceBetween: 20
      }
    },
    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  })